import { defineMessages } from 'react-intl';

export default defineMessages({
  startDate: {
    id: 'app.components.CreateShiftForm.startDate',
    defaultMessage: 'Starting date',
  },
  startTime: {
    id: 'app.components.CreateShiftForm.startTime',
    defaultMessage: 'Starting time',
  },
  endDate: {
    id: 'app.components.CreateShiftForm.endDate',
    defaultMessage: 'End date',
  },
  endTime: {
    id: 'app.components.CreateShiftForm.endTime',
    defaultMessage: 'End time',
  },
  dialogTitle: {
    id: 'app.components.CreateShiftForm.dialogTitle',
    defaultMessage: 'Create shift',
  },
  confirmShiftCreation: {
    id: 'app.components.CreateShiftForm.confirmShiftCreation',
    defaultMessage: 'Create shift',
  },
  cancelShiftCancellation: {
    id: 'app.components.CreateShiftForm.cancelShiftCancellation',
    defaultMessage: 'Cancel',
  },
  endDateMustBeAfterStartDate: {
    id: 'app.components.CreateShiftForm.endDateMustBeAfterStartDate',
    defaultMessage: 'End date must be after start date',
  },
  dateMustBeAlignedToFullOrHalfHour: {
    id: 'app.components.CreateShiftForm.dateMustBeAlignedToFullOrHalfHour',
    defaultMessage: 'Time must be aligned to full or half hour',
  },
});
